import { FC, Fragment } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Types
import QuizTypes from 'types/QuizTypes';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Async
import { createAnalyticsInteract } from 'store/player/playerAsync';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectResult } from 'store/player/playerSelectors';

const ProceedData:FC = () => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const quiz:any = useAppSelector(selectQuiz);
  const result:any = useAppSelector(selectResult);

  const handleProceedClick = () => {
    // if ( !quiz.callToAction.clickBonusPoints ) return;

    dispatch(createAnalyticsInteract({
      result: result.currentUserResult._id,
      name: 'proceedClick'
    }));
    // dispatch(increaseScore({
    //   resultId: result.currentUserResult._id,
    //   data: {
    //     numberOfPoints: quiz.callToAction.clickBonusPoints,
    //     interaction: 'proceedClick'
    //   }
    // }));
  }
  
  if ( [QuizTypes.Personality, QuizTypes.Poll, QuizTypes.Survey, QuizTypes.RankingPoll, QuizTypes.TeamSelector].includes(quiz.type) ) return null;
  if ( !quiz.callToAction.enabled ) return null;
  return (
    <Fragment>
      {quiz.callToAction.clickBonusPoints ? (
        <h3 className="text-center text-2xl text-primary font-bold px-4 mb-6">
          {t('pages.postQuiz.title', { points: quiz.callToAction.clickBonusPoints })}
        </h3>
      ) : null}
      {quiz.callToAction.image ? (
        <a
          className="block rounded mb-4 overflow-hidden border border-white"
          href={quiz.callToAction.url || undefined}
          target="_blank"
          rel="noreferrer"
          onClick={handleProceedClick}
        ><img src={quiz.callToAction.image} alt={quiz.callToAction.text || `${t('buttons.visit')} ${quiz.namespace}`} /></a>
      ) : null}

      {quiz.callToAction.url ? (
        <div className="text-center">
          <a
            className="
              py-2 px-4
              inline-block rounded-2xl
              font-semibold primary-button
            "
            href={quiz.callToAction.url}
            target="_blank"
            rel="noreferrer"
            onClick={handleProceedClick}
          >{quiz.callToAction.text || `${t('buttons.visit')} ${quiz.namespace}`}</a>
        </div>
      ) : null}
    </Fragment>
  )
}

export default ProceedData;
